<div class="container-surcharges-list">
  <div class="custom-table">
    <table>
      <thead>
        <tr class="border-0">
          <th scope="col">Code</th>
          <th scope="col">Surcharge</th>
          <th scope="col">Value ($)</th>
          <th scope="col">Tax Value ($)</th>
          <th scope="col">Description</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody *ngIf="surcharges?.length">
        <tr *ngFor="let item of surcharges">
          <td-copied [data]="item?.code"></td-copied>
          <td data-thead="Surcharge">
            {{ item?.surcharge | allLettersCapital }}
          </td>
          <td data-thead="Value ($)">{{ item?.amount }}</td>
          <td data-thead="Tax Value ($)">{{ item?.tax_amount }}</td>
          <td data-thead="Description">
            {{ $any(item)?.description?.['en'] || item?.description }}
          </td>
          <td data-thead="Status">
            <div class="edit-icon">
              <p-inputSwitch
                [disabled]="true"
                [ngModel]="item.is_active ? true : false"
              ></p-inputSwitch>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="isLoading">
        <tr *ngFor="let item of [1, 2, 3, 4, 5]">
          <td data-thead="Code">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="Surcharge">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="Value ($)">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="Tax Value ($)">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="Description">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="Status">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="Edit">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
      <!-- no data -->
      <tbody *ngIf="surcharges?.length == 0 && !isLoading">
        <tr>
          <td colspan="12" class="no-data">There Is No Data At The Moment</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
